<template>
<div class="container-fluid" >


<!-- Modal MESSAGE -->  
<modalMessage ref="msgModal"/>


 <div class="card border-success">
  
  <h4 class="card-header text-white bg-primary">        
     <i class="far fa-clock mr-2" aria-hidden="true"></i>
      VENDITE IN FASCIA ORARIA
  </h4>

  
    <div  class="card-body"> 

        <div v-if="type=='A'" class="" >

           <i style="color:blue" class="fas fa-stream mr-2" aria-hidden="true"></i>
          <strong>PARAMETRI DI RICERCA</strong>

        
         
        <hr>

<form v-on:submit.prevent="submit()">

  <div class="form-row align-items-center">

    <div class="col-sm-3">      
      <label class="sr-only_" for="inlineFormInputDate1"><strong>DA DATA VENDITA</strong></label>
      <input  required v-model="data1" type="date" id="inlineFormInputDate1" class="form-control" placeholder="" >              
    </div>

    <div class="col-sm-3">
      <label class="sr-only_" for="inlineFormInputDate2"><strong>A DATA VENDITA</strong></label>     
        <input required type="date" v-model="data2"  class="form-control" id="inlineFormInputDate2" placeholder="">     
    </div>

    <div class="col-sm-3 my-1 ">
      <store-select v-bind:props="store"  @update="setStoreId"></store-select>         
    </div>

    

  </div>
    <button type="submit" class="btn btn-primary mt-1 ml-3">ESEGUI RICERCA</button>
</form>  





        
        <div class="">


      

      </div>
      </div>

<div v-else>

 
      <button @click="type='A'" type="button"   class="btn btn-secondary ml-3 mr-2 mb-1">
            <i class="fas fa-reply mr-2"></i>      
              RITORNA A PARAMETRI RICERCA
      </button>   

           <!-- Example single danger button -->
    <div class="btn-group mb-1">
      <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
        <i class="fas fa-cog mr-2"></i>
        ESPORTA
      </button>
      <div class="dropdown-menu">
        <a v-if="1==0" :disabled="items.length==0" @click="pdf()" class="dropdown-item"  href="#">
          <i class="far fa-file-pdf mr-2"></i>
          IN FORMATO PDF</a>
        <a  :disabled="items.length==0" @click="exportCSV()" class="dropdown-item" href="#">
          <i class="fas fa-file-export mr-2"></i>
          IN FORMATO CSV</a>
        
        
        
        
      </div>
      </div>




 <div class="table-responsive">    
 <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table id='my-table' class="table table table-sm table-hover table-bordered table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th v-for="(col, index) in cols" :key="index" class="text-center" scope="col">{{col}}</th>
           
      </tr>
    </thead>
    <tbody>

      <tr  
      v-for="(item, index) in items" :key="index">    
        <td 
        :style = "{color: item[col]=='Domenica' ? 'red':'', backgroundColor : index == cols.length - 1 ? '#dbfedb' : ''  ,fontWeight : index == cols.length - 1 ? 'bold' : ''  }"
        v-for="(col, index) in cols" :key="index" class="text-right">
            <span v-if="index > 1">{{fmt1(item[col])}}</span> 
            <span v-else>{{item[col]}}</span> 
        </td>        
      </tr> 
    </tbody>
    <tfoot>
       <tr  :style = "{backgroundColor : '#dbfedb' ,fontWeight :  'bold'  }"
      v-for="(item, index) in total_row" :key="index">    
        <td 
        :style = "{backgroundColor : index == cols.length - 1 ? '#dbfedb' : ''  ,fontWeight :  'bold'  }"
        v-for="(col, index) in cols" :key="index" class="text-right">
            <span v-if="index > 1">{{fmt1(item[col])}}</span> 
            <span v-else>{{item[col]}}</span> 
        </td>        
      </tr> 



      
    </tfoot>
   
    
  </table>



</div>
</div> 


</div>  

</div>
</div> 
 


 


</div>


</template>
<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';


import storeSelect       from '@/components/common/StoreSelect_1.vue'
import jsPDF             from 'jspdf';
import fmt               from '@/components/mixins/fmt.js'

import modalMessage      from '@/components/modalDialog/ModalMessage.vue'   

//import 'jspdf-autotable'
//import autoTable from 'jspdf-autotable'

export default {
  mixins:[fmt],
  components: {storeSelect,modalMessage},
  data() {
    return {
      
    store             : 
    {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true
      },  
      data1           : null,
      data2           : new Date().toISOString().slice(0,10),
      
      alert           : false, 
      spinner         : false,
      spinner_pdf     : false,
   
      
      items           : [],
      title           : {},
      cols            : [],
      type            : 'A',
      total_row       : []
      
      
    }
  },

  computed :{
    ...mapGetters(['company']),

    
  
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

    //this.getGrouping()
  },
  methods: {


   header_pdf()
   {
      
     
    


   }, 
   exportCSV()
   {
    const csvData = this.toCSV(this.items)
    this.downloadCSV(csvData)
   },

   toCSV (data) {
      const headers = Object.keys(data[0]);

      const rows = data.map(obj =>
        headers.map(h => {
        
        let value = obj[h] != null ? obj[h] : "";
      
        // Escape virgolette
        value = String(value).replace(/"/g, '""');
        return `"${value}"`;
        }).join(",")
    );

      return [
        headers.join(","),  // intestazione
        ...rows
      ].join("\n");
},

  downloadCSV(csv, filename =  "VenditeFasciaOraria_" + this.title.store +  "_"  + ".csv") {


  
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
      a.href = url;
      a.download =  filename;
      a.click();

      URL.revokeObjectURL(url);
  },

   async  pdf()
    {

      
      const addFooters = doc => {
      const pageCount = doc.internal.getNumberOfPages()
      doc.setFont('helvetica', 'italic')
      doc.setFontSize(8)
      for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i)

        doc.text('Pag. ' + String(i) + ' di ' + String(pageCount), 50,200, {
        align: 'center'})
      }
      }
       
       this.spinner_pdf = true


       const doc = new jsPDF(
         
         {
         
       orientation: "landscape",

        
      })
      doc.setFontSize(8)
      
      doc.text("VENDITE SU FASCIA ORARIA " + this.title.store +  " dal  " +  this.data1 + ' al ' + this.data2 ,15,10)
      
      
      doc.autoTable(
      
    
       { 
       html         : '#my-table',
       margin       : {top:20},
       showFoot     : 'lastPage',
       footStyles   : {fontStyle:'bold',fillColor:'white',textColor:'black',fontSize:7,cellWidth: 'wrap',},

          /*  
          didParseCell: function(data) {
            if (data.row.cells[0].text == 'Totale') {
              
              
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.fontSize = 6
              //console.log(data.row.cells[0].text)

            }
          


          
          }, 
                */


       styles : {
          font       : 'helvetica',
          //rowHeight  : 5,  
          fontSize   : 6,
          }
        })
      
     
     addFooters(doc) 
    //var string = doc.output('datauristring');
    //doc.output('dataurlnewwindow');
    var fileName = 'Report'
    window.open(doc.output('bloburl', { filename: fileName }), '_blank');
    //console.log(string)
    this.spinner_pdf = false
    //doc.save('sellOut_' + Date.now()  + '.pdf', {returnPromise:true}).then(this.spinner_pdf=false);
      
     
    },
   
    setStoreId(storeId,e)
    {
      this.storeId = storeId
      this.title.store = e.target.options[e.target.options.selectedIndex].text

      
    },  
    
    submit() 
    {
     this.getData()
    },  
    
  
    async getData() {
          
      this.items     = []
      this.cols      = []            
      
      const sp = 'spTimeSlotSales'
      const payload  = {sp,

          'companyId':this.company.Id,'data1':this.data1,'data2':this.data2,'storeId':this.storeId
          
      }
      
      
         try{ 

            this.$refs.msgModal.show()        
            this.$refs.msgModal.setSpinner(true)  
            const res = await api.post(payload)
            if (res.status !== 200) 
            {
              throw new Error(res.data ||  res)
            }

              this.$refs.msgModal.close() 
              this.items = res.data.recordsets[0]
              
              if(this.items.length > 0 )
              {
                this.total_row = this.items.slice(this.items.length - 1)
                this.items     = this.items.slice(0, -1);
              
                this.cols = Object.keys(this.items[0])
                this.type = 'B'
              }
              else
              {
                throw 'DATI INESISTENTI.'
              }

            
          }
          catch(err)  
          {
              this.$refs.msgModal.setSpinner(false)
              this.$refs.msgModal.show(err,{},3) 

          }


    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 600px;
overflow   : auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;
    
    
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   :  rgb(222, 215, 215);
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    

 }

.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}

.table {
  border-collapse: separate;
}

</style>